import { render, staticRenderFns } from "./Componentes.vue?vue&type=template&id=0a146bb5&scoped=true&"
import script from "./Componentes.vue?vue&type=script&lang=js&"
export * from "./Componentes.vue?vue&type=script&lang=js&"
import style0 from "./Componentes.vue?vue&type=style&index=0&id=0a146bb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a146bb5",
  null
  
)

export default component.exports